module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-senha-step"
  }, [_c('h2', {
    staticClass: "aso-senha-step__title"
  }, [_vm._v("Crie sua Senha.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('input', {
    staticClass: "aso-senha-step__input",
    attrs: {
      "type": "password",
      "placeholder": "Digite a senha",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:password', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "aso-senha-step__input",
    attrs: {
      "type": "password",
      "placeholder": "Repita a senha",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.passwordConfirm
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:passwordConfirm', $event.target.value)
      },
      "blur": function($event) {
        return _vm.$emit('confirm-blur')
      }
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('p', {
    staticClass: "aso-senha-step__error"
  }, [_vm._v(_vm._s(_vm.passwordError))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "aso-senha-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.$emit('continue')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.busy ? 'Salvando...' : 'Continuar') + "\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "aso-senha-step__text"
  }, [_c('strong', [_vm._v("Seu e-mail será utilizado como login de acesso.")]), _vm._v(" Crie uma senha segura com ao menos 8 caracteres, incluindo letra maiúscula, minúscula, número e caractere especial.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c48054f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/funcionario/aso/assinar/AsoValidarSenhaStep.vue
// module id = 1507
// module chunks = 45